<template>
    <div>
        <v-container>
            <v-col v-if="!spinner && !showSuccess">
                <v-card>
                    <v-card-title>Reset Password</v-card-title>
                    <v-form ref="form" class="mx-2" lazy-validation>
                        <v-card-text>
                            <v-text-field v-model="pass1" v-on:keyup.enter="onEnter" type="password"
                                :rules="[v => !!v || 'Password is required']" label="Password" required>
                            </v-text-field>
                            <v-text-field v-model="pass2" v-on:keyup.enter="onEnter" type="password"
                                :rules="[v => !!v || 'Password is required']" label="Re-enter password" required>
                            </v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn v-on:click="ResetPassword" class="navColor float-right">Submit</v-btn>
                            </div>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
            <v-col v-if="showSuccess">
                <v-card>
                    <v-card-title>Password changed successfully</v-card-title>
                    <v-card-text>
                        You can now login with the new password set.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-on:click="returnToLogin" class="float-right"
                            :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">back to login</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col v-if="spinner" align="center">
                <v-progress-circular :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'" size="72"
                    indeterminate></v-progress-circular>
            </v-col>
        </v-container>
    </div>
</template>

<script>
import RestResource from '../RestResource.js';

const restResourceService = new RestResource();
export default {
    name: "ResetPasswordPage",
    setup() {

    },
    props: {

    },
    components: {

    },
    data: () => ({
        spinner: false,
        pass1: "",
        pass2: "",
        showSuccess: false,
    }),
    mounted: function () {

    },
    methods: {
        async ResetPassword() {
            this.spinner = true;
            let valid = this.$refs.form.validate();
            if (!valid) {
                this.spinner = false;
                this.$refs.form.reset();
                return this.$emit('snack', "Invalid Inputs");
            }
            if (this.pass1 != this.pass2) {
                this.spinner = false;
                this.$refs.form.reset();
                return this.$emit('snack', "Passwords must match");
            }
            if (this.pass1.length < 8) {
                this.spinner = false;
                this.$refs.form.reset();
                return this.$emit('snack', "Password must be more than 8 characters");
            }
            const isReset = await restResourceService.postUpdatePassword(this.pass1, this.pass2, this.$route.params.guid);
            this.spinner = false;
            if (isReset)
                this.showSuccess = true;

        },
        returnToLogin() {
            this.$router.push({ path: "/Login" });
        }
    },

}
</script>

<style scoped>
</style>